<template>
  <v-container fluid class="full-container scheduler-container">
    <v-row class="tabs-root">
      <v-toolbar flat fixed class="tabs-toolbar">
        <v-tabs
          v-model="tab"
          grow
          show-arrows
        >
          <v-tabs-slider/>
          <v-tab :href="`#${tabs()[0]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.scheduler.pages.launches.icon }}</v-icon>
            {{ lang.meta.pages.scheduler.pages.launches.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[1]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.scheduler.pages.calendar.icon }}</v-icon>
            {{ lang.meta.pages.scheduler.pages.calendar.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[2]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.scheduler.pages.list.icon }}</v-icon>
            {{ lang.meta.pages.scheduler.pages.list.title }}
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="permissions.scheduler.actions.new"
              v-on="on"
              @click.prevent="newDialog()"
              color="primary"
              class="mb-9"
              app
              fab
              bottom
              right
              fixed
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.scheduler.new.title }}</span>
        </v-tooltip>
        <ViewDialog
          v-if="dialog.selected"
          v-model="dialog.selected"
          :id="dialog.selected.id"
          :dialog="dialog.view"
          @closed="onCloseView"
        />
        <Save
          v-if="dialog.selected"
          v-model="dialog.selected"
          :id="dialog.selected.id"
          :dialog="dialog.save"
          @closed="onCloseSave"
          noOrder
        />
        <v-tabs-items v-model="tab">
          <v-tab-item :id="tabs()[0]">
            <Launches
              @view="viewDialog"
              @edit="editDialog"
            />
          </v-tab-item>
          <v-tab-item :id="tabs()[1]">
            <Calendar
              @view="viewDialog"
              @edit="editDialog"
            />
          </v-tab-item>
          <v-tab-item :id="tabs()[2]">
            <List
              @view="viewDialog"
              @edit="editDialog"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ViewDialog from '@/components/scheduler/View'
import Save from '@/components/scheduler/Save'
import Launches from '@/components/scheduler/launches/Launches'
import Calendar from '@/components/scheduler/calendar/Calendar'
import List from '@/components/scheduler/list/List'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import list from '@/mixins/defaults/list'

export default {
  components: { ViewDialog, Save, Launches, Calendar, List },
  mixins: [ appdata, utils, list ],
  data () {
    return {
      tab: null,
      tabs: function () {
        return [
          this.lang.meta.pages.scheduler.pages.launches.path,
          this.lang.meta.pages.scheduler.pages.calendar.path,
          this.lang.meta.pages.scheduler.pages.list.path
        ]
      },
      default: { ...defaults.blank.schedule },
      pageName: 'scheduler'
    }
  },
  computed: {
    items () {
      let schedules = this.get_data.schedules || {}
      return schedules.all || []
    }
  }
}
</script>

<style src="@/components/scheduler/styles/index.scss" lang="scss"></style>
